import { render, staticRenderFns } from "./PagePaymentTravelPackegeSuccess.vue?vue&type=template&id=8a166e2a&scoped=true"
import script from "./PagePaymentTravelPackegeSuccess.vue?vue&type=script&lang=js"
export * from "./PagePaymentTravelPackegeSuccess.vue?vue&type=script&lang=js"
import style0 from "./PagePaymentTravelPackegeSuccess.vue?vue&type=style&index=0&id=8a166e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a166e2a",
  null
  
)

export default component.exports